import React from 'react';
import BadgeBase from './BadgeBase';
import TEBadgeSignal from '../../types/TEBadgeSignal';

const Error = (props) => <BadgeBase {...props} signal={TEBadgeSignal.Error} />;

export default Error;
